import { ErrorCode } from '@ps/web-core-enums';

import type { Response } from '@swf/core/types/Account';

import { RealMoneyStatus } from '../types/status';

export const deRmfHandleResponse = (response: Response) => {
  let globalError;
  /* eslint-disable no-bitwise */
  if (response.regAction && response.regAction & (1 << 8)) {
    globalError = { code: RealMoneyStatus.DE_BANNED_BY_REGULATOR };
  } else if (response.regAction && response.regAction & (1 << 9)) {
    globalError = { code: RealMoneyStatus.DE_UNBANNED_BY_REGULATOR };
  } else if (
    response.errors &&
    response.errors?.code == ErrorCode.BLACKLIST_SERVICE_NOT_AVAILABLE
  ) {
    globalError = { code: RealMoneyStatus.BLACKLIST_SERVICE_NOT_AVAILABLE };
  }

  return globalError
    ? Promise.reject({
        body: {
          globalErrors: [globalError],
          fieldErrors: []
        }
      })
    : response.success;
};
